<app-popup>
  <div class="inner">
    <span class="default-cross" (click)="onClose()"></span>
    <div class="title" *ngIf='member?.id'>Редактировать связанное лицо</div>
    <div class="title" *ngIf='!member?.id'>Создать связанное лицо</div>
    <form class="form" [formGroup]="form">
      <div class="row">
        <div class="item"
             [class.error]="firstNameCtrl.touched && firstNameCtrl.errors || (firstNameCtrl.errors && submitting)">
          <label for="firstName" class="label required">Имя</label>
          <input trim="blur" type="text" class="input" id="firstName" [formControl]="firstNameCtrl" placeholder="имя">
        </div>
        <div class="item" [class.error]="secondNameCtrl.touched && secondNameCtrl.errors">
          <label for="secondName" class="label">Отчество</label>
          <input trim="blur" type="text" class="input" id="secondName" [formControl]="secondNameCtrl"
                 placeholder="отчество">
        </div>
        <div class="item"
             [class.error]="lastNameCtrl.touched && lastNameCtrl.errors || (lastNameCtrl.errors && submitting)">
          <label for="lastName" class="label required">Фамилия</label>
          <input trim="blur" type="text" class="input" id="lastName" [formControl]="lastNameCtrl" placeholder="фамилия">
        </div>
      </div>
      <div class="row">
        <div class="item" [class.error]="birthdayCtrl.touched && birthdayCtrl.errors">
          <label class="label required">Дата рождения</label>
          <app-datepicker placeholder="Дата рождения" [control]="birthdayCtrl"></app-datepicker>
        </div>
        <div class="item" [class.error]="phoneCtrl.touched && phoneCtrl.errors">
          <label for="phone" class="label">Контактный Телефон</label>
          <div class="item-phone">
            <input class="input-phone" trim="blur" type="text" id="phone" [formControl]="phoneCtrl"
                   placeholder="+380 50 123 45 67">
          </div>
        </div>
        <div class="item" [class.error]="emailCtrl.touched && emailCtrl.errors">
          <label for="email" class="label">E-mail</label>
          <input type="text" class="input" id="email" [formControl]="emailCtrl" placeholder="e-mail">
        </div>
      </div>
      <div class="row">
        <div class="item"
             [class.error]="ageTypeCtrl.touched && ageTypeCtrl.errors || (ageTypeCtrl.errors && submitting)">
          <label for="surname" class="label required">Возрастная категория</label>
          <select class="select" [formControl]="ageTypeCtrl" id="surname">
            <option disabled value="" selected hidden>Возрастная категория</option>
            <option *ngFor="let item of ageCategories" [value]="item.id">{{item.text}}</option>
          </select>
        </div>
        <div class="item half" [class.error]="commentCtrl.touched && commentCtrl.errors">
          <label for="comments" class="label">Комментарий</label>
          <input trim="blur" type="text" class="input" id="comments" [formControl]="commentCtrl"
                 placeholder="Комментарий">
        </div>
      </div>
    </form>

    <div class="buttons-wrapper">
      <button class="button blue-btn" (click)="onClose()"> Отмена</button>
      <button class="button red-btn" (click)="onSubmit()" [disabled]="submitPressed || (!form.valid && submitting)"> Сохранить</button>
    </div>
  </div>
</app-popup>
